import React from "react";
import { Flex } from "@chakra-ui/react";

const LargeContainer = ({
  height = "100%",
  width = "100%",
  flexDirection = "row",
  justifyContent = "center",
  backgroundColor = "#F5F5F5",
  align = "center",
  ...props
}) => {
  return (
    <Flex
      height={height}
      width={width}
      flexDirection={flexDirection}
      justifyContent={justifyContent}
      backgroundColor={backgroundColor}
      align={align}
      {...props}
    />
  );
};

export default LargeContainer;
